import { Typography } from "@circle-react-uikit/Typography";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useNavigate } from "@tanstack/react-router";
import isFunction from "lodash/isFunction";

import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal";
import { useOnboardingFlags } from "@/react/hooks/useOnboardingFlags";

interface HideOnboardingConfirmationProps {
  onClose?: () => void;
}

const HideOnboardingConfirmationModalComponent = ({
  onClose,
}: HideOnboardingConfirmationProps) => {
  const drawer = useModal();
  const navigate = useNavigate();
  const { currentCommunity } = usePunditUserContext();

  const { enableFlag } = useOnboardingFlags({
    onEnableFlagSuccess: () => {
      const isHomePageEnabled = currentCommunity?.home_page_enabled;
      isFunction(onClose) && onClose();
      void drawer.hide();
      if (isHomePageEnabled) {
        return void navigate({ to: "/home" });
      }
      window.location.href = "/";
    },
  });

  const onClickRemoveOnboarding = () => {
    enableFlag("getting_started_checklist_hidden");
  };

  return (
    <ConfirmationModal
      isOpen={drawer.visible}
      onClose={drawer.hide}
      title={t("remove_onboarding_confirmation_modal.title")}
      cancelText={t("remove_onboarding_confirmation_modal.cancel")}
      confirmText={t("remove_onboarding_confirmation_modal.confirm")}
      onConfirm={onClickRemoveOnboarding}
    >
      <Typography.BodyMd>
        {t("remove_onboarding_confirmation_modal.description")}
      </Typography.BodyMd>
    </ConfirmationModal>
  );
};

const HideOnboardingConfirmationModal = ModalManager.create(
  ({ onClose }: HideOnboardingConfirmationProps) => (
    <HideOnboardingConfirmationModalComponent onClose={onClose} />
  ),
);

export const useHideOnboardingConfirmationModal = () =>
  useModal(HideOnboardingConfirmationModal);
